import React, { useEffect } from "react";
import NavBar from "../NavBar";
import TopPanel from "../TopPanel";

import "./Page.css";
import { MoneyCorpPermissions } from "../../hooks/usePermissions/usePermissions";

const Page = (props: {
  title?: string;
  permissions?: MoneyCorpPermissions;
  children?: any[];
}) => {
  useEffect(() => {
    document.title = props.title || "MoneyCorp";
  }, [props.title]);

  return (
    <div className="Page-container">
      <div className="PageHeader-container">
        <TopPanel permissions={props.permissions} />
        <NavBar title={props.title} permissions={props.permissions} />
      </div>
      {props.children}
    </div>
  );
};

export default Page;
